import { __assign } from "tslib";
import { createEmailDashboardApi } from '.';
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
export var createEmailDashboardApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createEmailDashboardApi(parent, fakeHttp);
    var base = parent + "/dashboard/ticketing";
    var handler = {
        whenGetEmailDashboardData: createFakePostResponder(fakeHttp, "" + base),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map